import { useEffect } from 'react';
import { useCategorieStore } from '../store/categorieStore';

/**
 * Carica (una volta, via store condiviso) le categorie attive di settings_categorie_form
 * e le rende disponibili a chi ne ha bisogno. Espone loading/error per la UI.
 */
export function useCategorie() {
  const categorie = useCategorieStore((s) => s.categorie);
  const isLoading = useCategorieStore((s) => s.isLoading);
  const loaded = useCategorieStore((s) => s.loaded);
  const error = useCategorieStore((s) => s.error);
  const fetch = useCategorieStore((s) => s.fetch);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { categorie, isLoading, loaded, error };
}
